import React, {useState} from "react";
import useMedia from "use-media";
import {useDispatch, useSelector} from "react-redux";
import {selectCollapse} from "reducers/leftMenu";
import Private from "components/Private";
import {PortalFields} from "components/LeftMenu/LeftMenuLinks/models";
import {UserAccessFields} from "reducers/client";
import MobileFilterMenu from "components/MobileFilterMenu/MobileFilterMenu";
import FilterMenu from "components/FilterMenu/FilterMenu";
import {hideFilterMenu, selectFilterVisible, showFilterMenu} from "../../reducers/filterMenu";

type Props = {
  rightMenu?: React.ReactNode | null;
  children: React.ReactNode;
  portalConfigField?: keyof PortalFields;
  userAccessField?: keyof UserAccessFields;
  forceCollapseMenu?: boolean;
};

function Frame(props: Props): JSX.Element {
  const dispatch = useDispatch();
  const {rightMenu, children, portalConfigField, userAccessField, forceCollapseMenu = false} = props;
  const mobileBreakpoint = useMedia({maxWidth: 1024});
  const [menuCollapseDelay, setMenuCollapseDelay] = React.useState(false);
  const menuCollapsed = useSelector(selectCollapse);
  const filterCollapsed = !useSelector(selectFilterVisible);
  const [filterCollapsedOnLoad, setFilterCollapsedOnLoad] = useState(true);

  React.useEffect(() => {
    if (forceCollapseMenu) {
      setFilterCollapsedOnLoad(filterCollapsed);
      dispatch(hideFilterMenu());
    }
  }, []);

  React.useEffect(() => {
    if (forceCollapseMenu) {
      return () => {
        dispatch(filterCollapsedOnLoad ? hideFilterMenu() : showFilterMenu());
      }
    }
  }, [filterCollapsedOnLoad])

  React.useEffect(() => {
    setTimeout(() => {
      setMenuCollapseDelay(menuCollapsed);
    }, 300);
  }, [menuCollapsed]);

  return (
    <div className="View">
      <div>
        <Private portalConfigField={portalConfigField} userAccessField={userAccessField}>
          {children}
        </Private>
      </div>
      <MobileFilterMenu>{rightMenu}</MobileFilterMenu>
    </div>
  );
}

export default Frame;
